module.exports = __webpack_public_path__ + "48adea598c5cb6866dee9620e06ad92d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-basic-1.png
// module id = 1593
// module chunks = 0